const isElementTotallyVisible = (element) =>{
    if(element.current){
      let box = element.current.getBoundingClientRect();
      return box.top <= window.innerHeight;
    }
}



module.exports = isElementTotallyVisible;